import classNames from 'classnames';
import Link from 'next/link';
import { FC } from 'react';

import type { Venue as VenueModel } from 'types/domain';
import { useTranslation } from 'utils/i18n';

import AddToBookingButton from '../addToBookingButton';
import SpacePrice from '../spacePrice';

interface Space {
  id: number;
  name: string;
  priceIncVat: number;
  clinical: boolean;
}

type Venue = Pick<VenueModel, 'id'>;

interface Props {
  venue?: Venue;
  space: Space;
  disabled?: boolean;
  addedToBooking?: boolean;
  onAddToBooking?: (space: Space, venue: Venue) => void;
}

const SpaceDetails: FC<Props> = ({
  venue,
  space,
  space: { name, priceIncVat, clinical } = {} as Space,
  disabled = false,
  addedToBooking = false,
  onAddToBooking: addToBooking,
}) => {
  const { t } = useTranslation('common');
  const className = classNames(
    'calendar__space_details',
    clinical
      ? 'calendar__space_details--clinical'
      : 'calendar__space_details--non-clinical'
  );

  return (
    <div className={className}>
      <h4>
        <Link href={`${t('navigation.spaces.url')}/${space.id}`}>{name}</Link>
      </h4>
      <SpacePrice
        price={priceIncVat}
        labelPosition="side"
        labelText={t('space_list_item.price.per_hour')}
      />
      {addToBooking && (
        <span>
          <AddToBookingButton
            className="space-list-item__book-btn"
            onClick={() => addToBooking(space, venue!)}
            added={addedToBooking}
            enabled={!disabled}
            desktop
          />
        </span>
      )}
    </div>
  );
};

export default SpaceDetails;
